import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const buttonFn = /* @__PURE__ */ createRecipe('button', {}, [
  {
    "color": "primary",
    "size": "l",
    "css": {
      "textStyle": "button.l"
    }
  },
  {
    "color": "primary",
    "size": "m",
    "css": {
      "textStyle": "button.m"
    }
  },
  {
    "color": "primary",
    "size": "s",
    "css": {
      "textStyle": "button.s"
    }
  },
  {
    "color": "secondary",
    "size": "l",
    "css": {
      "textStyle": "button.l"
    }
  },
  {
    "color": "secondary",
    "size": "m",
    "css": {
      "textStyle": "button.m"
    }
  },
  {
    "color": "secondary",
    "size": "s",
    "css": {
      "textStyle": "button.s"
    }
  },
  {
    "color": "tertiary",
    "size": "l",
    "css": {
      "textStyle": "button.m"
    }
  },
  {
    "color": "tertiary",
    "size": "m",
    "css": {
      "textStyle": "button.m"
    }
  },
  {
    "color": "tertiary",
    "size": "s",
    "css": {
      "textStyle": "button.s"
    }
  }
])

const buttonVariantMap = {
  "color": [
    "primary",
    "secondary",
    "tertiary"
  ],
  "size": [
    "l",
    "m",
    "s"
  ],
  "stretch": [
    "text",
    "container"
  ]
}

const buttonVariantKeys = Object.keys(buttonVariantMap)

export const button = /* @__PURE__ */ Object.assign(memo(buttonFn.recipeFn), {
  __recipe__: true,
  __name__: 'button',
  __getCompoundVariantCss__: buttonFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: buttonVariantKeys,
  variantMap: buttonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, buttonVariantKeys)
  },
  getVariantProps: buttonFn.getVariantProps,
})